import { z } from "zod";

export const ApiErrorSchema = z.object({
  code: z.number(),
  message: z.string(),
});

export const ApiErrorListSchema = z.array(ApiErrorSchema);

export const ResponseSchema = z.object({
  result: z.any().optional(),
  errors: ApiErrorListSchema.or(z.null()),
});

export type ApiError = z.infer<typeof ApiErrorSchema>;
export type Response = z.infer<typeof ResponseSchema>;
